export interface BrandIP {
  id: string;
  name: string;
  description: string;
  category: "fashion" | "beauty" | "food" | "tech" | "lifestyle" | "sports";
  categoryLabel: string;
  logo: string;
  coverImage: string;
  accentColor: string;
  tokenReward: number;
  bonusMultiplier: number;
  ipAssets: BrandIPAsset[];
  totalUsage: number;
  activeQuests: number;
  verified: boolean;
  tagline: string;
}

export interface BrandIPAsset {
  id: string;
  brandId: string;
  name: string;
  description: string;
  type: "product" | "character" | "logo" | "pattern" | "fashion";
  image: string;
  tag: string;
  tokenBonus: number;
  usageCount: number;
  guidelines: string[];
}

export interface BrandCampaign {
  id: string;
  brandId: string;
  title: string;
  description: string;
  purpose: string;
  tokenPool: number;
  tokenPerUse: number;
  bonusCondition: string;
  deadline: string;
  participantCount: number;
  status: "active" | "upcoming" | "ended";
  requiredIPs: string[];
  thumbnail: string;
}

export const brands: BrandIP[] = [
  {
    id: "brand-001",
    name: "LUMI Cosmetics",
    tagline: "K-Beauty의 새로운 기준",
    description: "LUMI는 한국을 대표하는 프리미엄 뷰티 브랜드입니다. 팬 크리에이터들이 LUMI 제품을 영상에 활용하면 특별 토큰 보상을 드립니다.",
    category: "beauty",
    categoryLabel: "뷰티 / 코스메틱",
    logo: "https://public.readdy.ai/ai/img_res/defe7d0a250ac1c32a851c39e7220bff.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=premium%20korean%20beauty%20cosmetics%20product%20lineup%2C%20elegant%20rose%20gold%20packaging%2C%20luxury%20skincare%20bottles%20and%20jars%2C%20soft%20pink%20and%20white%20background%2C%20professional%20product%20photography%2C%20wide%20panoramic%20composition&width=1200&height=500&seq=brand-cover-001&orientation=landscape",
    accentColor: "#e8a0b4",
    tokenReward: 300,
    bonusMultiplier: 1.5,
    totalUsage: 8420,
    activeQuests: 12,
    verified: true,
    ipAssets: [
      {
        id: "ip-lumi-001",
        brandId: "brand-001",
        name: "LUMI 글로우 세럼",
        description: "베스트셀러 비타민C 글로우 세럼. 영롱한 유리병 디자인이 특징.",
        type: "product",
        image: "https://readdy.ai/api/search-image?query=premium%20vitamin%20C%20glow%20serum%20bottle%2C%20elegant%20glass%20packaging%2C%20rose%20gold%20cap%2C%20soft%20pink%20background%2C%20luxury%20skincare%20product%20photography%2C%20minimalist%20style%2C%20high%20quality&width=400&height=400&seq=lumi-ip-001&orientation=squarish",
        tag: "@LUMI_Serum",
        tokenBonus: 150,
        usageCount: 3241,
        guidelines: ["제품이 화면에 명확히 보여야 합니다", "긍정적인 맥락에서 사용해주세요", "LUMI 로고가 가려지지 않도록 해주세요"],
      },
      {
        id: "ip-lumi-002",
        brandId: "brand-001",
        name: "LUMI 립 컬렉션",
        description: "12가지 컬러의 벨벳 립스틱 컬렉션. 화려한 컬러 팔레트.",
        type: "product",
        image: "https://readdy.ai/api/search-image?query=luxury%20lipstick%20collection%2C%20multiple%20colors%20arranged%20beautifully%2C%20rose%20gold%20packaging%2C%20elegant%20display%2C%20beauty%20product%20photography%2C%20soft%20lighting%2C%20premium%20cosmetics&width=400&height=400&seq=lumi-ip-002&orientation=squarish",
        tag: "@LUMI_Lip",
        tokenBonus: 120,
        usageCount: 2187,
        guidelines: ["컬러가 선명하게 보이도록 조명을 설정해주세요", "제품 배치가 자연스러워야 합니다"],
      },
      {
        id: "ip-lumi-003",
        brandId: "brand-001",
        name: "LUMI 퍼퓸 오 드 파르팡",
        description: "시그니처 향수. 꽃잎 모양의 크리스탈 보틀 디자인.",
        type: "product",
        image: "https://readdy.ai/api/search-image?query=luxury%20perfume%20bottle%20crystal%20flower%20design%2C%20elegant%20fragrance%20packaging%2C%20soft%20pink%20and%20gold%20tones%2C%20premium%20beauty%20product%20photography%2C%20dreamy%20background&width=400&height=400&seq=lumi-ip-003&orientation=squarish",
        tag: "@LUMI_Perfume",
        tokenBonus: 200,
        usageCount: 1654,
        guidelines: ["향수 보틀의 크리스탈 디자인이 잘 보여야 합니다", "우아하고 고급스러운 분위기를 유지해주세요"],
      },
    ],
  },
  {
    id: "brand-002",
    name: "NOVA Streetwear",
    tagline: "거리에서 태어난 패션",
    description: "NOVA는 한국 스트리트 패션을 이끄는 브랜드입니다. 팬 크리에이터들이 NOVA 의류를 영상에 활용하면 토큰 보너스를 드립니다.",
    category: "fashion",
    categoryLabel: "패션 / 스트리트웨어",
    logo: "https://readdy.ai/api/search-image?query=streetwear%20fashion%20brand%20logo%2C%20bold%20modern%20typography%2C%20black%20and%20neon%20yellow%20color%20scheme%2C%20urban%20street%20culture%20branding%2C%20clean%20background%2C%20graphic%20design%20style&width=200&height=200&seq=brand-logo-002&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=korean%20streetwear%20fashion%20collection%2C%20urban%20style%20clothing%2C%20bold%20graphic%20tees%20and%20hoodies%2C%20neon%20yellow%20and%20black%20color%20scheme%2C%20street%20photography%20style%2C%20wide%20panoramic%20composition%2C%20energetic%20atmosphere&width=1200&height=500&seq=brand-cover-002&orientation=landscape",
    accentColor: "#f5e642",
    tokenReward: 250,
    bonusMultiplier: 1.4,
    totalUsage: 6130,
    activeQuests: 9,
    verified: true,
    ipAssets: [
      {
        id: "ip-nova-001",
        brandId: "brand-002",
        name: "NOVA 시그니처 후디",
        description: "NOVA 로고가 새겨진 오버사이즈 후드티. 블랙/화이트/옐로우 3가지 컬러.",
        type: "fashion",
        image: "https://readdy.ai/api/search-image?query=oversized%20hoodie%20streetwear%2C%20bold%20logo%20print%2C%20black%20and%20yellow%20color%2C%20urban%20fashion%20photography%2C%20clean%20background%2C%20modern%20street%20style%2C%20high%20quality%20product%20shot&width=400&height=400&seq=nova-ip-001&orientation=squarish",
        tag: "@NOVA_Hoodie",
        tokenBonus: 130,
        usageCount: 2890,
        guidelines: ["NOVA 로고가 선명하게 보여야 합니다", "스트리트 감성의 배경을 추천합니다", "착용 모습이 자연스러워야 합니다"],
      },
      {
        id: "ip-nova-002",
        brandId: "brand-002",
        name: "NOVA 카고 팬츠",
        description: "멀티 포켓 카고 팬츠. 실용적이면서 스타일리시한 디자인.",
        type: "fashion",
        image: "https://readdy.ai/api/search-image?query=cargo%20pants%20streetwear%20fashion%2C%20multiple%20pockets%2C%20urban%20style%2C%20black%20and%20olive%20color%2C%20street%20photography%2C%20modern%20fashion%20product%20shot%2C%20clean%20background&width=400&height=400&seq=nova-ip-002&orientation=squarish",
        tag: "@NOVA_Cargo",
        tokenBonus: 100,
        usageCount: 1876,
        guidelines: ["전신 샷에서 팬츠가 잘 보여야 합니다", "도시적인 배경을 활용해주세요"],
      },
      {
        id: "ip-nova-003",
        brandId: "brand-002",
        name: "NOVA 스니커즈 X1",
        description: "NOVA 한정판 콜라보 스니커즈. 독특한 솔 디자인과 형광 포인트.",
        type: "fashion",
        image: "https://readdy.ai/api/search-image?query=limited%20edition%20sneakers%2C%20bold%20design%2C%20neon%20yellow%20accent%2C%20street%20style%20footwear%2C%20product%20photography%2C%20clean%20white%20background%2C%20premium%20shoe%20design&width=400&height=400&seq=nova-ip-003&orientation=squarish",
        tag: "@NOVA_X1",
        tokenBonus: 180,
        usageCount: 1364,
        guidelines: ["스니커즈 디자인이 명확히 보여야 합니다", "형광 포인트가 잘 드러나는 조명을 사용해주세요"],
      },
    ],
  },
  {
    id: "brand-003",
    name: "ZENITH Tech",
    tagline: "미래를 입다",
    description: "ZENITH는 웨어러블 테크 브랜드입니다. 스마트워치, 이어버드 등 제품을 영상에 활용하면 토큰 보너스를 드립니다.",
    category: "tech",
    categoryLabel: "테크 / 웨어러블",
    logo: "https://readdy.ai/api/search-image?query=wearable%20tech%20brand%20logo%2C%20futuristic%20minimalist%20design%2C%20dark%20navy%20and%20cyan%20color%20scheme%2C%20technology%20company%20branding%2C%20clean%20background%2C%20modern%20geometric%20style&width=200&height=200&seq=brand-logo-003&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=wearable%20technology%20product%20lineup%2C%20smartwatch%20and%20earbuds%2C%20futuristic%20dark%20background%2C%20cyan%20and%20navy%20blue%20lighting%2C%20premium%20tech%20product%20photography%2C%20wide%20panoramic%20composition&width=1200&height=500&seq=brand-cover-003&orientation=landscape",
    accentColor: "#00d4ff",
    tokenReward: 350,
    bonusMultiplier: 1.6,
    totalUsage: 4870,
    activeQuests: 7,
    verified: true,
    ipAssets: [
      {
        id: "ip-zenith-001",
        brandId: "brand-003",
        name: "ZENITH 스마트워치 Z7",
        description: "AMOLED 디스플레이의 프리미엄 스마트워치. 미래지향적 디자인.",
        type: "product",
        image: "https://readdy.ai/api/search-image?query=premium%20smartwatch%20futuristic%20design%2C%20AMOLED%20display%2C%20dark%20metallic%20case%2C%20cyan%20accent%2C%20tech%20product%20photography%2C%20dark%20background%2C%20high%20quality%20wearable%20device&width=400&height=400&seq=zenith-ip-001&orientation=squarish",
        tag: "@ZENITH_Z7",
        tokenBonus: 200,
        usageCount: 2134,
        guidelines: ["워치 페이스가 선명하게 보여야 합니다", "미래지향적인 분위기를 연출해주세요", "손목 착용 샷을 권장합니다"],
      },
      {
        id: "ip-zenith-002",
        brandId: "brand-003",
        name: "ZENITH 에어팟 프로 X",
        description: "노이즈 캔슬링 무선 이어버드. 투명 케이스 디자인.",
        type: "product",
        image: "https://readdy.ai/api/search-image?query=wireless%20earbuds%20transparent%20case%2C%20premium%20audio%20product%2C%20futuristic%20design%2C%20dark%20background%20with%20cyan%20lighting%2C%20tech%20product%20photography%2C%20high%20quality%20earphones&width=400&height=400&seq=zenith-ip-002&orientation=squarish",
        tag: "@ZENITH_AirX",
        tokenBonus: 150,
        usageCount: 1876,
        guidelines: ["이어버드 디자인이 명확히 보여야 합니다", "음악 감상 장면에 자연스럽게 활용해주세요"],
      },
    ],
  },
  {
    id: "brand-004",
    name: "BLOOM Lifestyle",
    tagline: "일상을 특별하게",
    description: "BLOOM은 라이프스타일 브랜드입니다. 홈 데코, 문구류, 생활용품을 영상에 활용하면 토큰 보너스를 드립니다.",
    category: "lifestyle",
    categoryLabel: "라이프스타일",
    logo: "https://readdy.ai/api/search-image?query=lifestyle%20brand%20logo%2C%20elegant%20floral%20minimalist%20design%2C%20sage%20green%20and%20cream%20color%20scheme%2C%20modern%20lifestyle%20branding%2C%20clean%20background%2C%20botanical%20style&width=200&height=200&seq=brand-logo-004&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=lifestyle%20brand%20product%20collection%2C%20home%20decor%20and%20stationery%2C%20sage%20green%20and%20cream%20tones%2C%20cozy%20aesthetic%2C%20wide%20panoramic%20composition%2C%20warm%20natural%20lighting%2C%20minimalist%20style&width=1200&height=500&seq=brand-cover-004&orientation=landscape",
    accentColor: "#7ec8a0",
    tokenReward: 200,
    bonusMultiplier: 1.3,
    totalUsage: 3560,
    activeQuests: 5,
    verified: true,
    ipAssets: [
      {
        id: "ip-bloom-001",
        brandId: "brand-004",
        name: "BLOOM 아로마 캔들 세트",
        description: "천연 소이 왁스 아로마 캔들 3종 세트. 우드 위크 디자인.",
        type: "product",
        image: "https://readdy.ai/api/search-image?query=luxury%20aromatherapy%20candle%20set%2C%20natural%20soy%20wax%2C%20elegant%20glass%20containers%2C%20sage%20green%20and%20cream%20packaging%2C%20warm%20candlelight%2C%20lifestyle%20product%20photography%2C%20cozy%20atmosphere&width=400&height=400&seq=bloom-ip-001&orientation=squarish",
        tag: "@BLOOM_Candle",
        tokenBonus: 100,
        usageCount: 1543,
        guidelines: ["캔들 불꽃이 자연스럽게 보여야 합니다", "아늑하고 따뜻한 분위기를 연출해주세요"],
      },
      {
        id: "ip-bloom-002",
        brandId: "brand-004",
        name: "BLOOM 노트북 & 펜 세트",
        description: "고급 가죽 커버 노트북과 골드 펜 세트. 감성적인 문구류.",
        type: "product",
        image: "https://readdy.ai/api/search-image?query=premium%20leather%20notebook%20and%20gold%20pen%20set%2C%20elegant%20stationery%2C%20sage%20green%20and%20cream%20tones%2C%20lifestyle%20product%20photography%2C%20desk%20setup%2C%20minimalist%20aesthetic&width=400&height=400&seq=bloom-ip-002&orientation=squarish",
        tag: "@BLOOM_Note",
        tokenBonus: 80,
        usageCount: 1234,
        guidelines: ["노트북 커버 디자인이 보여야 합니다", "감성적인 데스크 셋업 장면을 권장합니다"],
      },
    ],
  },
];

export const brandCampaigns: BrandCampaign[] = [
  {
    id: "bc-001",
    brandId: "brand-001",
    title: "LUMI x K-POP 뷰티 챌린지",
    description: "K-POP 아이돌 영상에 LUMI 제품을 자연스럽게 활용하세요. 뷰티와 K-POP의 완벽한 조화를 보여주세요.",
    purpose: "LUMI 신제품 글로우 세럼의 K-POP 팬덤 내 인지도 확산 및 바이럴 마케팅",
    tokenPool: 500000,
    tokenPerUse: 300,
    bonusCondition: "LUMI IP 2개 이상 활용 시 50% 보너스",
    deadline: "2026-05-31",
    participantCount: 2341,
    status: "active",
    requiredIPs: ["ip-lumi-001", "ip-lumi-002"],
    thumbnail: "https://readdy.ai/api/search-image?query=kpop%20beauty%20collaboration%20campaign%2C%20idol%20with%20luxury%20cosmetics%2C%20pink%20and%20rose%20gold%20aesthetic%2C%20promotional%20campaign%20visual%2C%20elegant%20composition&width=600&height=400&seq=bc-001&orientation=landscape",
  },
  {
    id: "bc-002",
    brandId: "brand-002",
    title: "NOVA 스트리트 댄스 챌린지",
    description: "NOVA 의류를 착용한 댄스 영상을 제작하세요. 스트리트 감성과 K-POP 안무의 만남.",
    purpose: "NOVA 신시즌 컬렉션 홍보 및 MZ세대 타겟 바이럴 캠페인",
    tokenPool: 350000,
    tokenPerUse: 250,
    bonusCondition: "NOVA 의류 3종 이상 착용 시 40% 보너스",
    deadline: "2026-06-15",
    participantCount: 1876,
    status: "active",
    requiredIPs: ["ip-nova-001", "ip-nova-002"],
    thumbnail: "https://readdy.ai/api/search-image?query=streetwear%20fashion%20dance%20challenge%2C%20urban%20style%20clothing%2C%20energetic%20dance%20performance%2C%20neon%20yellow%20and%20black%20aesthetic%2C%20street%20photography%20style&width=600&height=400&seq=bc-002&orientation=landscape",
  },
  {
    id: "bc-003",
    brandId: "brand-003",
    title: "ZENITH 미래 테크 영상 챌린지",
    description: "ZENITH 웨어러블 기기를 활용한 미래지향적 영상을 제작하세요.",
    purpose: "ZENITH Z7 스마트워치 신제품 런칭 캠페인 및 테크 인플루언서 확보",
    tokenPool: 420000,
    tokenPerUse: 350,
    bonusCondition: "ZENITH IP 2종 동시 활용 시 60% 보너스",
    deadline: "2026-07-01",
    participantCount: 987,
    status: "active",
    requiredIPs: ["ip-zenith-001", "ip-zenith-002"],
    thumbnail: "https://readdy.ai/api/search-image?query=futuristic%20tech%20wearable%20campaign%2C%20smartwatch%20and%20earbuds%2C%20dark%20background%20with%20cyan%20lighting%2C%20technology%20lifestyle%20photography%2C%20modern%20aesthetic&width=600&height=400&seq=bc-003&orientation=landscape",
  },
];
